import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_ACCESS_NETWORK_ROLLOUT_INLCM_1 = {
  title:
    "Revolutionize your network rollout with \nour automated design system. Simply \nupload your data, visualize it on an \ninteractive map, and optimize builds \nusing layered GIS features. \n\nExperience seamless deployment \nefficiency at your fingertips.",
  subtitle: "Access Network Rollout",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_316"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_315"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_01_map_1.png",
          imageStyle: { position: "absolute", bottom: "308px", right: "103px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_01_map_2.png",
          imageStyle: { position: "absolute", bottom: "231px", right: "114px" },
        },
      ]}
      pageNumber={"ENG_3155"}
    />
  ),
};
